import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ContentLoading = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 150px)',
        width: '100%',
      }}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        style={{ marginRight: '10px' }}
        size="large"
        tip="Cargando..."
        wrapperClassName="text-center"
        fullscreen
        spinning
      />
    </div>
  );
};

export default ContentLoading;
